import { ProductType } from 'components/shared/Cart/types';
import { productMap_home } from 'content/products/uhHome';
import { getAttr } from 'lib/commerce/cart/policies/cartLineHelpers';
import type { CartLineAttribute } from 'lib/commerce/cart/types';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

type CartLike = Record<string, unknown> | null | undefined;

const lineAttr = (node: unknown, key: string): string | undefined => {
  if (!node || typeof node !== 'object') return undefined;
  const attributes = (node as { attributes?: CartLineAttribute[] }).attributes;
  if (!Array.isArray(attributes)) return undefined;
  return getAttr(attributes, key);
};

const cartEdges = (cart: CartLike): Array<{ node?: unknown }> => {
  if (!cart || typeof cart !== 'object') return [];
  const lines = (cart as { lines?: { edges?: unknown } }).lines;
  const edges = lines?.edges;
  return Array.isArray(edges) ? (edges as Array<{ node?: unknown }>) : [];
};

export function cartHasHomeLine(
  cart: CartLike,
  store: ShopifyStore | null,
): boolean {
  const edges = cartEdges(cart);
  if (!edges.length || !store) return false;
  const homeVariantId = productMap_home.variantId[store];
  return edges.some(({ node }) => {
    if (lineAttr(node, '_product_type') === 'HOME') return true;
    if (!homeVariantId || !node || typeof node !== 'object') return false;
    const merchandise = (node as { merchandise?: { id?: string } }).merchandise;
    return merchandise?.id === homeVariantId;
  });
}

/** Shop, buy-page, and upsell one-time adds set this. Membership adds omit it. */
export const ONE_TIME_M1_OFFER = 'otp';

export function cartHasM1Line(cart: CartLike): boolean {
  return cartEdges(cart).some(
    ({ node }) => lineAttr(node, '_product_type') === ProductType.M1,
  );
}

export function cartHasOneTimeM1Line(cart: CartLike): boolean {
  return cartEdges(cart).some(
    ({ node }) =>
      lineAttr(node, '_product_type') === ProductType.M1 &&
      lineAttr(node, '_m1_offer') === ONE_TIME_M1_OFFER,
  );
}

export function shouldApplyHomeCampaign({
  pathname,
  cartHasHome,
  isHomeProductTypePresent,
}: {
  pathname: string;
  cartHasHome: boolean;
  isHomeProductTypePresent?: boolean;
}): boolean {
  return (
    cartHasHome ||
    isHomeProductTypePresent === true ||
    pathname.startsWith('/home')
  );
}

export function shouldApplyM1Campaign({
  oneTimeM1,
  uhxOverridesCampaign = false,
}: {
  /** True only for a one-time M1 line or an add that carries `_m1_offer=otp`. */
  oneTimeM1: boolean;
  uhxOverridesCampaign?: boolean;
}): boolean {
  if (uhxOverridesCampaign) return false;
  return oneTimeM1;
}
